import { render, staticRenderFns } from "./UpdatePlanPrevention.vue?vue&type=template&id=6b079b90&"
import script from "./UpdatePlanPrevention.vue?vue&type=script&lang=ts&"
export * from "./UpdatePlanPrevention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports